/* Section navigation follows ordinary scrolling. The ecosystem owns its own motion. */
(() => {
  const boot = (scope = document) => {
    const pages = scope.matches?.('[data-gg-underground]') ? [scope] : scope.querySelectorAll('[data-gg-underground]');
    pages.forEach(page => {
      if (page.dataset.ggUndergroundReady) return;
      const links = [...page.querySelectorAll('.gg-ug-nav a[href^="#"]')];
      const destinations = links.map(link => page.querySelector(link.hash));
      let frame = 0, disposed = false;
      const update = () => {
        frame = 0;
        if (disposed || document.hidden) return;
        let current = 0;
        destinations.forEach((target, i) => { if (target && target.getBoundingClientRect().top <= innerHeight * .4) current = i; });
        links.forEach((link, i) => i === current ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
      };
      const schedule = () => { if (!frame && !disposed) frame = requestAnimationFrame(update); };
      addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule, { passive: true });
      page.dataset.ggUndergroundReady = 'true'; update();
      const cleanup = event => {
        if (!event.target.contains(page)) return;
        disposed = true; removeEventListener('scroll', schedule); removeEventListener('resize', schedule);
        if (frame) cancelAnimationFrame(frame);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
